import { render } from "./ContribuableDetails.vue?vue&type=template&id=c8180bd4"
import script from "./ContribuableDetails.vue?vue&type=script&lang=js"
export * from "./ContribuableDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__